import Cookies from "js-cookie";

const cookiesMandatory = [
  "cookies-accept",
  "JSESSIONID",
  "ARRAffinity",
  "ARRAffinitySameSite",
  "edb_v",
  "edb_r_v",
  "num-of-items-in-tables",
];

export function stopTracking() {
  gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
  gtag("set", { allow_google_signals: false });
  gtag("set", { allow_ad_personalization_signals: false });
  gtag("config", { allow_ad_personalization_signals: false });
  window.clarity("consent", false);
  window.clarity("stop");
  window["ga-disable-G-KJDRQBXSC3"] = true;
}

export function setCookisAccept() {
  Cookies.set("cookies-accept", "all", { expires: 365 });
  gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });
  window.clarity("consent");
  window.clarity("start");
  window["ga-disable-G-KJDRQBXSC3"] = false;
}

export function setCookisDenied() {
  Cookies.set("cookies-accept", "rejected", { expires: 365 });
  stopTracking();
}

